import { useTranslate } from 'react-t7e';
import { InputFormik, InputProps } from 'src/components/common/Input';
import LookingGlass from 'src/components/icons/LookingGlass';
import { FilterInputDescription } from 'src/components/filters/types';
import { CommonInputToFastFieldProps } from 'src/utils/formik/commonInputToFastField';

export function FilterSearchInput({
  filter,
  ...props
}: { filter: FilterInputDescription } & Partial<
  CommonInputToFastFieldProps<InputProps>
>) {
  const { _ } = useTranslate();
  return (
    <InputFormik
      validateOnBlur
      icon={<LookingGlass />}
      name={filter.queryField}
      labelSpace={false}
      placeholderVariant="hide"
      placeholder={_(filter.title)}
      {...props}
    />
  );
}
